import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from "@/components/ui/command";
import { ChevronsUpDown, Check, X } from "lucide-react";

// Single-select searchable dropdown for onboarding initial-password recipient.
export const RecipientPicker = ({ t, recipients, value, onChange, placeholder }) => {
  const [open, setOpen] = useState(false);
  const selected = recipients.find((r) => r.email === value);
  return (
    <div className="relative w-full">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" role="combobox" aria-expanded={open} data-testid="onboard-pwrec-select"
            className={`w-full justify-between rounded-sm border-zinc-300 font-normal ${value ? "pr-16" : "pr-9"}`}>
            <span className="truncate text-left">
              {selected ? selected.label : <span className="text-zinc-400">{placeholder}</span>}
            </span>
            <ChevronsUpDown size={15} className="ml-2 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[--radix-popover-trigger-width] rounded-sm p-0" align="start">
          <Command filter={(val, search) => {
            const r = recipients.find((x) => x.email === val);
            const hay = `${r?.label || ""} ${r?.email || ""}`.toLowerCase();
            return hay.includes(search.toLowerCase()) ? 1 : 0;
          }}>
            <CommandInput placeholder={t("onb.pwRecSearch")} data-testid="onboard-pwrec-search" />
            <CommandList>
              <CommandEmpty>{t("onb.cloneNoMatch")}</CommandEmpty>
              {recipients.map((r) => (
                <CommandItem key={r.email} value={r.email} data-testid={`onboard-pwrec-opt-${r.email}`}
                  onSelect={(v) => { onChange(v === value ? "" : v); setOpen(false); }}>
                  <Check size={15} className={`mr-2 shrink-0 ${value === r.email ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{r.label}</span>
                </CommandItem>
              ))}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      {value && (
        <button type="button" data-testid="onboard-pwrec-clear" aria-label="Clear recipient"
          onClick={() => onChange("")}
          className="absolute right-8 top-1/2 z-10 -translate-y-1/2 p-0.5 text-zinc-400 hover:text-red-500">
          <X size={14} />
        </button>
      )}
    </div>
  );
};
